import { render, staticRenderFns } from "./ItsBasePackAddressInspect.vue?vue&type=template&id=4a619767&scoped=true&"
import script from "./ItsBasePackAddressInspect.vue?vue&type=script&lang=js&"
export * from "./ItsBasePackAddressInspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a619767",
  null
  
)

export default component.exports